export const scheduleQKeys = {
  all: () => ["schedule"] as const,
  allWithFilters: (filters: any) => [...scheduleQKeys.all(), filters] as const,
};
